import { render } from "./register-two.vue?vue&type=template&id=d1e4576a"
import script from "./register-two.vue?vue&type=script&lang=js"
export * from "./register-two.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__